import { lazy } from 'react';




//sets the pages display settings

const QuickCompLoginConfig = {
  settings: {
    layout: {
        style : 'layout1',
        config: {
          
            navbar : {
                display : false,
                
            },
            toolbar: {
                display : false,
            },
            footer : {
                display : false,
                
            },
            mode   : 'fullwidth'
        }
    },
    
},
  routes: [
    {
      path: '/company-login',
      component: lazy(() => import('./QuickCompLogin')),
    },
  ],
};

export default QuickCompLoginConfig
